import type { User, UserSettings } from "@common/types/User";
import { useMutation } from "@tanstack/react-query";
import { apiClient } from "apiClient";

import { queryClient } from "helpers/queryClient";

import { queryKey as currentUserQueryKey } from "./useCurrentUser";

const useUserSettingMutation = <K extends keyof UserSettings>(settingKey: K) => {
  const { isPending, mutate } = useMutation({
    mutationFn: (value: UserSettings[K]) =>
      apiClient.user.updateCurrentUserSettings({
        [settingKey]: value
      } as Partial<UserSettings>),
    onSuccess: (data) => {
      queryClient.setQueryData(currentUserQueryKey(), (currentUser: User) => ({
        ...currentUser,
        [settingKey]: data[settingKey as keyof typeof data]
      }));
    }
  });

  return { update: mutate, isUpdating: isPending };
};

export default useUserSettingMutation;
